import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function FAQSection() {
  const faqs = [{
    q: '¿Esto reemplaza mi tratamiento médico?',
    a: 'No. Es un complemento espiritual y físico para mejorar tu calidad de vida diaria.'
  }, {
    q: '¿Cuánto tiempo me tomará cada mañana?',
    a: 'Menos de 5 minutos, y la mayoría se hace sin salir de la cama.'
  }, {
    q: '¿Y si fallo un día?',
    a: 'El método incluye un protocolo de Gracia de repuesto para reiniciar sin culpa.'
  }, {
    q: '¿Necesito conocimientos previos de la Biblia?',
    a: 'No, todas las herramientas y versículos vienen explicados de forma sencilla.'
  }];
  return <section className="py-20 md:py-24 px-6 bg-white" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-12 text-center" data-id="element-16">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-17">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-18">
              <div className="p-6 rounded-2xl bg-cream border border-divider/50" data-id="element-19">
                <h3 className="font-serif text-xl text-navy mb-3" data-id="element-20">{faq.q}</h3>
                <p className="text-navy/70 leading-relaxed" data-id="element-21">{faq.a}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}